var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClarify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.937,
    height: 22.921,
    viewBox: "0 0 22.937 22.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.438 -18.744)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.782 23.08)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.647 1.647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.592,43.683A3.809,3.809,0,1,1,40.4,39.874,3.813,3.813,0,0,1,36.592,43.683Zm0-6.943a3.133,3.133,0,1,0,3.133,3.133A3.137,3.137,0,0,0,36.592,36.74Z",
    transform: "translate(-32.783 -36.065)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.93,45.439a1.219,1.219,0,0,1-.868-.358l-3.807-3.807a5.461,5.461,0,1,1,1.587-1.512.338.338,0,1,1-.554-.387A4.774,4.774,0,1,0,36.1,40.563a.357.357,0,0,1,.276-.054.393.393,0,0,1,.233.164L40.539,44.6a.569.569,0,0,0,.781,0,.553.553,0,0,0,0-.781l-3.205-3.206a.338.338,0,0,1,.478-.478l3.2,3.206a1.227,1.227,0,0,1-.867,2.095Z",
    transform: "translate(-27.908 -31.19)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.108 9.675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.173,61.338a.338.338,0,0,1-.239-.577l.826-.826a.338.338,0,0,1,.478.478l-.826.826A.335.335,0,0,1,58.173,61.338Z",
    transform: "translate(-57.835 -59.837)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.638 18.944)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.637,67.315h-7.31a1.691,1.691,0,0,1-1.689-1.689V58.316a.338.338,0,0,1,.676,0v7.311a1.014,1.014,0,0,0,1.013,1.013h7.311a.338.338,0,1,1,0,.675Z",
    transform: "translate(-15.638 -57.978)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.2 13.184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.367,67.316H55.057a.338.338,0,1,1,0-.675h7.311a1.014,1.014,0,0,0,1.013-1.013v-7.31a.338.338,0,1,1,.675,0v7.311A1.691,1.691,0,0,1,62.367,67.316Z",
    transform: "translate(-54.719 -57.979)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.719,28.281a.337.337,0,0,1-.338-.338V20.633a1.014,1.014,0,0,0-1.013-1.013h-7.31a.338.338,0,0,1,0-.676h7.311a1.691,1.691,0,0,1,1.689,1.689v7.311A.338.338,0,0,1,63.719,28.281Z",
    transform: "translate(-54.72 -18.944)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.976,28.281a.337.337,0,0,1-.338-.338V20.633a1.691,1.691,0,0,1,1.689-1.689h7.311a.338.338,0,0,1,0,.676H17.327a1.014,1.014,0,0,0-1.013,1.013v7.311A.338.338,0,0,1,15.976,28.281Z",
    transform: "translate(-15.638 -18.944)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarify);
export default __webpack_public_path__ + "static/media/clarify.aefe2523.svg";
export { ForwardRef as ReactComponent };